/**
 * Created by rak on 1/15/2016.
 */
'use strict';

angular.module('trackMap')
  .controller('MappingGroupCtrl', function ($scope, widgetSettingsCreatorService, commonTrackService, $timeout, $rootScope, $interval) {
    //var vehicleGroup = {};

    var mainUrlDetails = '';

    mainUrlDetails = '&page=map.fleet.full&searchAndRoute_dsa=true&buildingSiteLocationBtn=true';

    var loadFleetServerDetails = function () {
      return commonTrackService.getFleetServerDetails().then(function (fleetServerDetails) {
        $scope.fleetServerUrl = fleetServerDetails.qualifiedServerURL;
        $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails, 'trackMapDashboard');
      });
    };
    // remove for Exhibition
    //loadFleetServerDetails();
    $scope.mVehicGroupSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'groupID'
    });

    $scope.mapVehicleSettings = widgetSettingsCreatorService.createComboxSettings({
      displayMember: 'description',
      valueMember: 'deviceID',
      disabled: true
    });

    var loadVehicleGroup = function () {
      return commonTrackService.getVehicleGroupComboList().then(function (vechileGroupList) {
        if (vechileGroupList.length > 0) {
          $scope.mVehicGroupSettings.source = vechileGroupList;
          var cachedGroup = commonTrackService.getCachedVehicleGroup(vechileGroupList);

          if(commonTrackService.isLocalOrconfigVehicleGroupValid(vechileGroupList, cachedGroup)){// validate the local storage group is still valid ( group can change based on login )
            $scope.vehicleGroup = cachedGroup;
          }

          if(!$scope.vehicleGroup ){
            $scope.vehicleGroup = vechileGroupList[0].groupID;
          }

        }
      });
    };

    var loadVehicle = function (groupId) {
      return commonTrackService.getVehicleListFilterByGroupId(groupId).then(function (vehicleList) {
        $scope.mapVehicleSettings.source = _.uniq(vehicleList, 'deviceID');
        $timeout(function () {
          $('#mapVehicleComboBox').jqxComboBox({
            disabled: false,
            selectedIndex: -1,
            height: 32,
            autoDropDownHeight: false
          });
        }, 0);
      });
    };

    loadFleetServerDetails().then(function () {
      return loadVehicleGroup();
    }).finally(function () {
      $scope.dataLoadingFinished = true;
    });

    // remove for Exhibition
    $scope.$on('mVehicleGroupComboChange', function () {
      var vehicleGroup = $('#mVehicGroupComboBox').jqxComboBox('getSelectedItem');
      if (vehicleGroup.value) {
        $scope.mapVehicleSettings.source = [];
        $('#mapVehicleComboBox').jqxComboBox({disabled: true, selectedIndex: -1});
        loadVehicle(vehicleGroup.value);
        $timeout(function () {
          $scope.mapUrl = commonTrackService._functionUpdateMapUrl($scope.fleetServerUrl, mainUrlDetails, 'trackMapDashboard');
          $scope.mapUrl += '&group=' + vehicleGroup.value;
        }, 0);
      }
    });
    $scope.$on('mapVehicleComboChange', function () {
      var vehicle = $('#mapVehicleComboBox').jqxComboBox('getSelectedItem');
      if (vehicle && vehicle.value) {
        commonTrackService.iframePostMessage('jsmShowDetailPushpin(' + 0 + ', 0 ,' + '"' + vehicle.value + '"' + ' ,' + true + ')', 'trackMapDashboard');
      }

    });

    $scope.$on('map_init_event', function () {
      $scope.counter = counterSeconds;
      $scope.startCounter();
    });
    //
    $scope.$on('map_place_route_int_event', function () {
      commonTrackService.iframePostMessage('stopAutoUpdateMapTimer()', 'trackMapDashboard');
      $scope.$apply($scope.isTimerStated = false);
      $scope.stop();
    });
    $scope.$on('map_option_canceled_event', function () {
      if (!$scope.isTimerStated) {
        commonTrackService.iframePostMessage('stopAutoUpdateMapTimer()', 'trackMapDashboard');
        $scope.isTimerStated = false;
        $scope.stop();
        commonTrackService.iframePostMessage('startAutoUpdateMapTimer()', 'trackMapDashboard');
        $scope.counter = counterSeconds;
        $scope.startCounter();
      }

    });


    var mapVehicleComboBoxClearEvt = $rootScope.$on('combobox-clear-selection-evt', function (event, data) {
      if (data.id === 'mVehicGroupComboBox') {
        $scope.mapVehicleSettings.source = [];
      }
    });


    //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
    // Google maps takes focus if the auto refresh enabled
    // Auto refresh must be stoped if the chat window is open to solve focus switching
    var chatWindowOpenEvent = $scope.$on('chat-window-open-evt', function () {
      $scope.stopAutoRefresh(null, 'stop');
    });
    //Bug 104150 - Messaging: Focus lost if vehicle-grid reloads
    //  restart the auto refresh is the chat window is closed
    var chatWindowCloseEvent = $scope.$on('chat-window-close-evt', function () {
      $scope.stopAutoRefresh(null, 'start');
    });


    $scope.$on('$destroy', function () {
      if(chatWindowOpenEvent){
        chatWindowOpenEvent();
      }
      if(chatWindowCloseEvent){
        chatWindowCloseEvent();
      }
      mapVehicleComboBoxClearEvt();
    });

    var counterSeconds = 60;
    var counterTimeout;

    $scope.startCounter = function () {
      $scope.stop();
      $scope.isTimerStated = true;
      if ($scope.counter - 1 >= 1) {
        $scope.counter--;
        counterTimeout = $interval($scope.startCounter, 1000);
      } else {
        $scope.stop();
        $scope.counter = counterSeconds;
        $scope.startCounter();

      }
    };
    $scope.stop = function () {
      $interval.cancel(counterTimeout);
    };

    $scope.stopAutoRefresh = function () {

      if ($scope.isTimerStated) {
        $scope.isTimerStated = false;
        $scope.stop();
        commonTrackService.iframePostMessage('stopAutoUpdateMapTimer()', 'trackMapDashboard');
      } else {
        $scope.counter = counterSeconds;
        $scope.startCounter();
        commonTrackService.iframePostMessage('startAutoUpdateMapTimer()', 'trackMapDashboard');
        $scope.isTimerStated = true;
      }
    };

  });



// WEBPACK FOOTER //
// ./.tmp/components/track/mapping/groupMapController.js